import $ from 'jquery';
import ModalVideoWithParameters from '../../components/modal-video-with-parameters';
import MenuWidget from '../../components/menu-widget';
$(() => {
    MenuWidget.init();
    ModalVideoWithParameters.init();
});
